<template>
  <div class>
    <!-- header start -->
    <van-nav-bar
      title="关注热门馆"
      fixed
      :z-index="99"
      left-arrow
      @click-left="onClickLeft"
      :border="false"
    />
    <div class="navBarSpace"></div>
    <!-- header end -->
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
      <van-list
        v-model="loading"
        :finished="finished"
        :offset="offset"
        :immediate-check="ischeck"
        finished-text="没有更多了"
        @load="loadMore"
      >
        <div v-for="item in dataList" :key="item.id">
          <router-link
            class="search-list van-hairline--bottom"
            :to="{path:'/MemorialHall', query:{id:item.SerialNumber}}"
          >
            <div class="hd">
              <div class="image">
                <van-image round fit="cover" :src="item.DeceasedPhotoPath" />
              </div>
            </div>
            <div class="bd">
              <h2 class="title">{{item.DeceasedFullName}}</h2>
              <p class="des van-ellipsis">建馆人：{{item.MemberNickName}}</p>
              <p class="des van-ellipsis">{{item.DeceasedLifeIntroduction}}</p>
            </div>
            <div class="ft" @click.prevent="clickfollow(item)">
              <van-button v-if="item.IsRelative" color="#999" size="small">已关注</van-button>
              <van-button v-else type="danger" size="small">+ 关注</van-button>
            </div>
          </router-link>
        </div>
      </van-list>
    </van-pull-refresh>
    <!-- <div>
      <router-link
        class="search-list van-hairline--bottom"
        to="/MemorialHall"
        v-for="item in 10"
        :key="item.id"
      >
        <div class="hd">
          <div class="image">
            <van-image round fit="cover" src="https://img.yzcdn.cn/vant/cat.jpeg" />
          </div>
        </div>
        <div class="bd">
          <h2 class="title">丢丢</h2>
          <p class="des van-ellipsis">建馆人：张三</p>
          <p class="des van-ellipsis">悄悄地走，正如我瞧瞧的来。</p>
        </div>
        <div class="ft">
          <van-button v-if="item == 1" color="#999" size="small">已关注</van-button>
          <van-button v-else type="danger" size="small">+ 关注</van-button>
        </div>
      </router-link>
    </div>-->
  </div>
</template>

<script>
import { Toast } from "vant";

export default {
  //
  data() {
    return {
      keyword: "",
      refreshing: false,
      loading: true,
      finished: false,
      offset: 100,
      ischeck: false,
      options: null,
      dataList: []
    };
  },
  components: {},
  methods: {
    onClickLeft() {
      this.$router.go(-1);
    },
    init() {
      var that = this;
      that.options = {
        type: "MemorialManageGetHotMemorialHallList",
        TodayType: 2,
        pageIndex: 1
      };
      that.getList();
    },
    loadMore() {
      Object.assign(this.options, {
        pageIndex: this.options.pageIndex + 1
      });
      this.loading = true;
      this.getList();
    },
    onRefresh() {
      this.finished = false;
      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true;
      Object.assign(this.options, {
        pageIndex: 1
      });
      this.getList();
    },
    getList() {
      var that = this;
      this.$store.dispatch(this.options).then(
        res => {
          console.log(res);
          that.loading = false;
          if (that.refreshing) {
            that.refreshing = false;
          }
          var dataList = res.MemorialHallList;
          if (dataList.length < 10) {
            that.finished = true;
          }

          if (this.options.pageIndex > 1) {
            if (dataList.length > 0) {
              dataList.forEach(element => {
                that.dataList.push(element);
              });
            }
          } else {
            that.dataList = dataList;
          }
        },
        error => {}
      );
    },
    clickfollow(item) {
      //addFollowMemorialHall
      var that = this;
      this.$store
        .dispatch({
          type: "addFollowMemorialHallVue",
          IsAuth: true,
          MId: item.MemorialHallID
        })
        .then(
          res => {
            Toast(res.Message);
            if (res.IsSuccess) {
              item.IsRelative = res.Information == "true";
            }
          },
          error => {}
        );
    }
  },
  created() {
    var that = this;
    that.init();
  }
};
</script>

<style scoped>
</style>